import React, { useEffect } from "react"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { getFormIsSubform, getFormQuestions } from "reduxSlices/formBuilderSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
import { LOCATION_TYPE } from "views/Forms/FormElementTypes"
/* eslint-disable max-len */
import TaskDepartmentByQuestionSelector from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskDepartmentByQuestionSelector"
/* eslint-enable max-len */

const TaskMemberDepartmentSelector = () => {
  const {
    addMemberDepartmentByQuestionUUID,
    taskMemberDepartments,
  } = useTaskFormContext()

  const selectedQuestionUUIDs = new Set(taskMemberDepartments?.map((dept) => dept.questionUUID))
  const isSubform = useSelector(getFormIsSubform)
  const allQuestions = useSelector(getFormQuestions, isEqual)

  const selectableQuestions = allQuestions.filter((question) => (
    question.type === LOCATION_TYPE && !selectedQuestionUUIDs.has(question.uuid)
  ))

  useEffect(() => {
    window.dispatchEvent(new window.Event("resize"))
  }, [taskMemberDepartments])

  if (isSubform || selectableQuestions.length === 0) return null

  return (
    <TaskDepartmentByQuestionSelector
      onChange={addMemberDepartmentByQuestionUUID}
      questions={selectableQuestions}
    />
  )
}

export default TaskMemberDepartmentSelector
